(() => {
  const initPack = (form) => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const products = JSON.parse(form.querySelector('[data-pack-products]').textContent);
    const model = form.querySelector('[data-pack-model]');
    const variants = form.querySelector('[data-pack-variant]');
    const total = form.querySelector('[data-pack-total]');
    const status = form.querySelector('[data-pack-status]');
    const button = form.querySelector('[data-pack-submit]');
    const picture = form.closest('.tdp-pack').querySelector('[data-pack-image]');
    const capPrice = Number(form.dataset.capPrice);
    const discountedCap = Math.round(capPrice * 0.9);
    const money = (cents) => new Intl.NumberFormat('fr-CA', {style: 'currency', currency: form.dataset.currency}).format(cents / 100) + ' ' + form.dataset.currency;
    const label = (title) => title.replace(/Heather True Royal/g, 'Bleu chiné').replace(/Heather Raspberry/g, 'Framboise chiné').replace(/Black/g, 'Noir').replace(/Blue/g, 'Bleu');
    const updatePrice = () => {
      const product = products[model.value];
      const variant = product.variants.find((v) => String(v.id) === variants.value);
      if (!variant) return;
      total.textContent = money(variant.price + discountedCap);
      form.querySelector('[data-pack-saving]').textContent = money(capPrice - discountedCap);
      button.disabled = !variant.available;
      status.textContent = variant.available ? '' : 'Cette variante est épuisée. Choisis une autre taille ou couleur.';
      const image = variant.featured_image?.src || product.image;
      picture.removeAttribute('srcset');
      picture.src = image;
      picture.alt = product.title + ' — ' + label(variant.title);
      form.querySelector('[data-pack-product-link]').href = product.url + '?variant=' + variant.id;
    };
    model.addEventListener('change', () => {
      variants.replaceChildren();
      for (const variant of products[model.value].variants) {
        const option = new Option(label(variant.title) + ' — ' + money(variant.price) + (variant.available ? '' : ' · Épuisé'), variant.id);
        option.disabled = !variant.available;
        variants.add(option);
      }
      const available = products[model.value].variants.find((variant) => variant.available);
      if (available) variants.value = String(available.id);
      updatePrice();
    });
    variants.addEventListener('change', updatePrice);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      status.textContent = 'Ajout de ton duo…';
      try {
        const response = await fetch(form.action + '.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: Number(variants.value), quantity: 1}, {id: Number(form.dataset.capId), quantity: 1}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Ajout impossible. Vérifie les disponibilités.');
        window.location.assign(form.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Connexion interrompue. Vérifie ton panier avant de réessayer.';
        button.disabled = false;
      }
    });
    updatePrice();
  };
  const initSticky = () => {
    const link = document.querySelector('[data-tdp-sticky]');
    if (!link || link.dataset.ready) return;
    const form = document.getElementById(link.dataset.form);
    if (!form) return;
    link.dataset.ready = 'true';
    const price = form.querySelector('.product__price');
    const copyPrice = () => { link.querySelector('[data-sticky-price]').textContent = (price?.querySelector('.js-price, .product__price--sale, .product__price--reg')?.innerText.trim() || '') + ' CAD'; };
    copyPrice();
    if (price) new MutationObserver(copyPrice).observe(price, {subtree:true,childList:true,characterData:true});
    new IntersectionObserver(([entry]) => { link.hidden = entry.isIntersecting; }, {threshold:0.1}).observe(form);
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const group = [...form.querySelectorAll('.tdp-options')].find((item) => /taille|size/i.test(item.querySelector('legend')?.textContent || '')) || form;
      group.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
      const target = group.querySelector('.tdp-option:not(:disabled), select:not(.tdp-native-control), button[type="submit"]');
      if (target) target.focus({preventScroll:true});
    });
  };
  const init = () => {document.querySelectorAll('[data-tdp-pack]').forEach(initPack);initSticky();};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
